<template>
<div class="header">
  <!-- logo -->
  <div class="header__logo_outer">
    <div class="header__logo_inner">
      <a href="/"><img src="../assets/logo4.gif" /></a>
    </div>

    <!-- underlogo menu -->
    <div class="header__logomenu">
      <a class="header__menuitem" href="/">RPG Planet</a>
      <a class="header__menuitem">SteelWorld</a>{{' '}}
      <a class="header__menuitem">Правила</a>
      <a class="header__menuitem" href="http://www.city-of-masters.ru/forums/index.php?s=&showtopic=3675&view=findpost&p=146926">Живое обсуждение в {{new Date().getFullYear()}}</a>

      <div class="header__menu_rightalign">
        <a class="header__menuitem">Магазин</a>{{' '}}
        <a class="header__menuitem">Помощь</a>{{' '}}
        <a class="header__menuitem">Поиск</a>{{' '}}
        <a class="header__menuitem">Участники</a>{{' '}}
        <a class="header__menuitem">Календарь</a>{{' '}}
        <a class="header__menuitem">Ссылки</a>{{' '}}
        <a class="header__menuitem">Галерея</a>
      </div>
    </div>
  </div>

  <!-- Здравствуйте Гость ( Вход | Регистрация )  -->

  <!-- Breadcrumbs -->
  <div class="header__breadcrumbs">
    <img src="../assets/nav.gif" /> <a href="/">RPG Planet Board</a>
    <template v-for="breadcrumb in breadcrumbs"> > <a :href="'index.php?showforum=' + breadcrumb[0]">{{htmlDecode(breadcrumb[1])}}</a> </template>
  </div>

  <!-- С возвращением; Ваш последний визит: ... [Имя пользователя] [******] логин-->
</div>
</template>


<script>
export default {
  props: ['breadcrumbs'] // now use {{breadcrumbs}}
}
</script>

<style lang="scss">
@import "./Header.scss";
</style>
